import React from 'react';
import {
  Alert,
  AlertIcon,
  AlertDescription,
  Box,
  Link,
  CloseButton,
} from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';

/**
 * DemoBanner — sticky top banner shown only when the app is running in demo
 * mode (hostname is demo.frontdesko.app or REACT_APP_DEMO=true).
 *
 * Renders nothing for normal logged-in users: the caller in App.js only
 * mounts this when isDemoMode() returns true.
 */
const DemoBanner = ({ onDismiss }) => {
  const { t } = useTranslation();
  return (
    <Box
      position="sticky"
      top={0}
      zIndex={9999}
      width="100%"
    >
      <Alert
        status="info"
        bg="blue.600"
        color="white"
        borderRadius={0}
        px={4}
        py={3}
        alignItems="center"
        justifyContent="center"
      >
        <AlertIcon color="white" />
        <AlertDescription fontSize="sm" fontWeight="medium">
          <Trans
            i18nKey="ui:demoBanner.message"
            components={{
              link: (
                <Link
                  href="https://frontdesko.app/signup"
                  isExternal
                  color="white"
                  fontWeight="bold"
                  textDecoration="underline"
                  _hover={{ opacity: 0.85 }}
                  aria-label={t('ui:demoBanner.trialLinkAria')}
                />
              ),
            }}
          />
        </AlertDescription>
        {onDismiss && (
          <CloseButton
            position="absolute"
            right={2}
            top="50%"
            transform="translateY(-50%)"
            color="white"
            onClick={onDismiss}
            aria-label={t('ui:demoBanner.dismissAria')}
          />
        )}
      </Alert>
    </Box>
  );
};

export default DemoBanner;
